import { PayloadAction } from "@reduxjs/toolkit";

export function setCommonFilterValueReducer(
  state,
  action: PayloadAction<{ id: string; enabled: boolean }>,
) {
  state.filters = state.filters.map((f) => {
    if (f.id === "common") {
      return {
        ...f,
        filters: f.filters.map((ff) =>
          ff.id === action.payload.id ? { ...ff, enabled: action.payload.enabled } : ff,
        ),
      };
    }
    return f;
  });
}
